import { Flex, FlexProps, Icon, IconProps } from '../../atoms';

export function SquareIcon({
  iconProps,
  ...rest
}: { iconProps: IconProps } & FlexProps): JSX.Element {
  return (
    <Flex
      h="40px"
      w="40px"
      padding="space_unit.x1"
      backgroundColor="palette_blue.5"
      borderRadius="radii.x2"
      alignItems="center"
      justifyContent="center"
      {...rest}
    >
      <Icon
        color="palette_blue.100"
        w="24px"
        h="24px"
        {...iconProps}
        name={iconProps.name}
      />
    </Flex>
  );
}
